import '@pds/navigationPrimary/navigationPrimary.min.css';
import React, { useContext } from 'react';
import { LocalizationContext } from '../app';

export interface HeaderProps {
  changeLanguage: (newLang: string) => void;
}

const Header: React.FunctionComponent<HeaderProps> = (props: HeaderProps) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const localization = useContext(LocalizationContext)!;

  let skipToMain = 'Skip to main content';
  let skipToFooter = 'Skip to footer';
  let skipLinks = 'Skip links';
  // let changeLang = 'Español';

  // const changeLangHandler = (event: React.MouseEvent<HTMLElement>): void => {
  //   event.preventDefault();
  //   props.changeLanguage(localization.resolvedLanguage === 'en' ? 'es' : 'en');
  // };

  if (localization.isInitialized) {
    skipToMain = localization.t('misc:skip-to-content');
    skipToFooter = localization.t('misc:skip-to-footer');
    skipLinks = localization.t('misc:skip-links');
    // changeLang = localization.t('misc:change-lang');
  }

  const langSwitcher = <></>;
  // const langSwitcher = (
  //   <a className="pds-link" href={localization.resolvedLanguage === 'en' ? '#?lng=es' : '#?lng=en'} onClick={changeLangHandler}>
  //     {changeLang}
  //   </a>
  // );

  return (
    <nav className="pds-navigationPrimary-horizontal-white" style={{ overflowY: 'hidden' }}>
      <div id="load_focus" aria-label={skipLinks}>
        <a className="pds-navigationPrimary-skip-to-content-link" href="#main">
          {skipToMain}
        </a>
        <a className="pds-navigationPrimary-skip-to-content-link" href="#footer">
          {skipToFooter}
        </a>
      </div>
      <div className="pds-navigationPrimary-container container" style={{ justifyContent: 'space-between' }}>
        <div className="pds-navigationPrimary-logo">
          <a className="pds-navigationPrimary-logo-link pds-link-unstyled" href="/http.www/" aria-label="asdf">
            <img alt="" className="logo-gradient-right" />
          </a>
        </div>
        <div>{langSwitcher}</div>
      </div>
    </nav>
  );
};

export default Header;
